export enum EUSSStatus {
  SETTLED = 'Settled',
  PRE_SETTLED = 'Pre-Settled'
}

export enum AppliedEUSSStatus {
  GRANTED = 'Yes',
  APPLIED = 'No, but I have applied for it',
  WILL_APPLY = 'No, but I will apply for it',
  NO = 'No'
}
